const API = process.env.REACT_APP_BACKEND_URL;

/** Step 5 of the Chinnu physical purchase flow — creates a server-side
 * PAYMENT_PENDING order + Razorpay order before checkout can open. */
export async function createPhysicalOrder(payload) {
  const res = await fetch(`${API}/api/store/physical/order/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = Array.isArray(data.detail)
      ? data.detail.map((d) => (d.msg || "").replace(/^Value error,\s*/i, "")).join(" ")
      : data.detail || "Could not start your order — please try again.";
    throw new Error(detail);
  }
  return data;
}

/** Step 8 — server-side verified Razorpay signature + captured payment. */
export async function verifyPhysicalOrder(payload) {
  const res = await fetch(`${API}/api/store/physical/order/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res.json();
}

/** Confirmation-page fetch — gated by the signed, order-scoped token. */
export async function getPhysicalOrderConfirmation(orderRef, token) {
  const url = new URL(`${API}/api/store/physical/order/${encodeURIComponent(orderRef)}`);
  if (token) url.searchParams.set("token", token);
  const res = await fetch(url.toString());
  return res.json();
}

/** Self-service "track my order" lookup — gated by order ref + the email
 * used to place it, for a customer who doesn't have their confirmation
 * link/token handy. */
export async function trackPhysicalOrder(orderRef, email) {
  const res = await fetch(`${API}/api/store/physical/order/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ order_ref: orderRef, email }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not look up your order right now. Please try again.");
  }
  return res.json();
}
